import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aciair/flightmatrix'
import pathMap from 'src/paths/pathMap'

class FlightMatrixRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.FLIGHT_MATRIX_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.FLIGHT_MATRIX_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.FLIGHT_MATRIX_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.FLIGHT_MATRIX_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default FlightMatrixRoute
